'use client'

import dynamic from 'next/dynamic'
import { useRef, useState } from 'react'
import { SwiperRef } from 'swiper/react'
import { Image } from '../ml-images'
import { Building, Coin } from '../../atoms'

// Code-split Swiper out of the main bundle — this card is used in below-the-fold
// carousels, so its JS shouldn't count against the critical/hydration bundle.
const SwiperEngine = dynamic(() => import('./SwiperEngine').then((mod) => mod.SwiperEngine))

export interface MlIllustratedCardProps {
  images: Image[]
  title: string
  description: string
  price: string
  floor: string
}

const detailClasses = 'flex gap-2 items-center text-neutrals-800 text-14 leading-1.5'

export const MlIllustratedCard = ({ description, floor, images, price, title }: MlIllustratedCardProps) => {
  const swiper = useRef<SwiperRef>(null)
  const [beginning, setBeginning] = useState(true)
  const [end, setEnd] = useState(false)

  // illustration-card class is used for overrides for the bullet color (grouping), they're on the overrides.css file in ml-images folder
  // same for default swiper styles, imported in ml-images so no need to import them again (due to bundling)
  return (
    <div className="illustration-card border-1 bg-neutrals-white border-neutrals-300 rounded-4 max-w-full w-[25rem] lg:w-[20.3125rem]">
      <SwiperEngine
        swiperRef={swiper}
        images={images}
        beginning={beginning}
        end={end}
        onBeginningChange={setBeginning}
        onEndChange={setEnd}
      />
      <div className="pt-8 p-6">
        <p className="font-heading text-neutrals-900 font-medium text-20 leading-1.3 mb-1 line-clamp-1">{title}</p>
        <p className="text-14 leading-1.5 text-neutrals-800 mb-4 line-clamp-3">{description}</p>
        <div className={`${detailClasses} mb-3`}>
          <Coin className="shrink-0" />
          <span className="line-clamp-1">{price}</span>
        </div>
        <div className={detailClasses}>
          <Building className="shrink-0" />
          <span className="line-clamp-1">{floor}</span>
        </div>
      </div>
    </div>
  )
}
